import type { IconSvgObject } from './types';

const ArrowLeft01Icon: IconSvgObject = [
  ["path", { d: "M15 6L9 12.0001L15 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default ArrowLeft01Icon;
